var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 5.94656L17.9023 17.8724H4.09734L10.9998 5.94656ZM10.9998 2.28906L0.916504 19.7057H21.0832L10.9998 2.28906Z",
    fill: "#F1C036"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9165 15.1224H10.0832V16.9557H11.9165V15.1224Z",
    fill: "#F1C036"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9165 9.6224H10.0832V14.2057H11.9165V9.6224Z",
    fill: "#F1C036"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlert);
export default __webpack_public_path__ + "static/media/ic_alert.5b30a5883a9696a33c2ba96a87e2a46f.svg";
export { ForwardRef as ReactComponent };